<script setup lang="ts" generic="T extends Record<string, any>">
import { watch } from 'vue';

const loading = defineModel<boolean>('loading', { default: false });

const props = defineProps<{ fallback: boolean }>();

const emits = defineEmits<{ (e: 'fallback'): void }>();

watch(
  () => props.fallback,
  () => {
    if (props.fallback && !loading.value) {
      emits('fallback');
    }
  },
  { immediate: true }
);
</script>

<template>
  <template v-if="loading">
    <div class="loader__inner">
      <p>De actuele accommodatiegegevens worden opgehaald...</p>
      <div class="loader__animation">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 46 38">
          <defs>
            <filter id="a" color-interpolation-filters="auto">
              <feColorMatrix in="SourceGraphic" values="0 0 0 0 0.007843 0 0 0 0 0.031373 0 0 0 0 0.529412 0 0 0 1.000000 0" />
            </filter>
            <path id="b" d="M0 0h44.648v37H0z" />
          </defs>
          <g fill="none" fill-rule="evenodd" filter="url(#a)" transform="translate(-222 -155)">
            <g transform="translate(222.676 155.84)">
              <mask id="c" fill="#fff"><use xlink:href="#b" /></mask>
              <path
                fill="#1E1E1C"
                d="M25.205 7.206A3.816 3.816 0 0021.71.424a3.816 3.816 0 003.495 6.782zm18.123 22.497a1.9 1.9 0 00-2.395 1.235c-.414 1.295-1.594 2.198-2.87 2.256l-12.148-.014.788-7.005a3.815 3.815 0 00-2.63-4.062l-4.329-1.39-9.492.144a5.07 5.07 0 003.231 3.199l8.044 2.578-.738 6.531-17.704-.021a1.91 1.91 0 00-1.907 1.904 1.899 1.899 0 001.904 1.906L38.139 37a6.997 6.997 0 002.916-.779 7.075 7.075 0 003.503-4.13 1.904 1.904 0 00-1.23-2.388zM3.005 18.255l.007 2.008a3.112 3.112 0 002.848-1.897l4.187-.066c-.004.01 0 .018-.003.029l10.156-.157 1.815-2.098 1.148 1.116a3.783 3.783 0 002.704 1.083l5.16-.067a2.54 2.54 0 10-.062-5.082l-4.631.054-3.072-2.995c-1.453-1.414-4.95-2.509-7.397.308l-4.552 5.252-5.544.086c-.507-1.035-1.55-1.758-2.773-1.754l.006 1.937-.014.008-2.685.758a.406.406 0 00-.291.302c-.054.224.08.45.305.504l2.688.671z"
                mask="url(#c)"
              />
            </g>
          </g>
        </svg>
      </div>
    </div>
  </template>
  <template v-else-if="!loading && fallback">
    <slot name="fallback" />
  </template>
  <template v-else>
    <slot />
  </template>
</template>
